<template>
	<v-tooltip top>
		<template v-slot:activator="{ on }">
			<v-chip  :small="small" v-on="on" class="ml-3 mr-4 remove_clone"  dark :color="scoreColor(score)">{{score}}</v-chip>
		</template>
		<span>Score</span>
	</v-tooltip>
</template>
<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	// import - from "@/components/"
	export default {
		name: "ScoreBadge", 
		props: {
			small: {type: Boolean, default: false },
			level: {},

		},
		data: () => {
			return {

			}
		},
		// components: {

		// },
		computed: {
			...Vuex.mapState( {
				assessments: state => state.assessments
			}),
			assessment(){ 
				return this.assessments[0] || {}
			},
			score(){
				return this.assessment.scores[this.level] || 0;
			},
		},
		// methods: {
		// }
		// created(){
			
		// }

	}
</script>"